import { Authenticator } from "@aws-amplify/ui-react";
import { fetchAuthSession } from "aws-amplify/auth";
import React from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

export default function App()
{
    const requestInterceptor = React.useCallback(async (request) =>
    {
        // const endpoint = new URL(request.url);

        try {

            console.log('request', request);

            const session = await fetchAuthSession();
            const AccessKeyId = session.credentials.accessKeyId;
            const SecretKey = session.credentials.secretAccessKey;
            const SessionToken = session.credentials.sessionToken;

            const endpoint = new URL(request.headers.endpoint);
            const newUrl = new URL(request.url);

            // console.log('request', "SessionToken", SessionToken, "AccessKeyId", AccessKeyId, "SecretKey", SecretKey);

            const hostUrl = endpoint.hostname;

            function extractRegion(url)
            {
                const regex = /execute-api\.(.*?)\.amazonaws/;
                const match = url.match(regex);
                return match ? match[1] : null;
            }

            const hostRegion = extractRegion(hostUrl);

            // const apiId = hostUrl.split('.')[0]; // Extract API ID from the hostname

            console.log('newUrl.search', newUrl.search);

            function sortQueryParamsLexically(queryString)
            {
                let params = new URLSearchParams(queryString);

                let paramsArray = Array.from(params.entries());

                paramsArray.sort(([keyA], [keyB]) => keyA.localeCompare(keyB));

                let sortedQuery = paramsArray.map(([key, value]) => `${ key }=${ encodeURIComponent(value) }`).join('&');

                return sortedQuery;
            }

            request.body = JSON.stringify({
                SecretKey,
                AccessKeyId,
                SessionToken,
                method: request.method,
                path: endpoint.pathname,
                apiQuery: sortQueryParamsLexically(newUrl.search.slice(1)),
                apiBody: request.body ? JSON.parse(request.body) : undefined,
                hostUrl,
                hostRegion
            });

            request.url = `${ newUrl.origin }/predev/public/swagger`;
            // request.url = `http://localhost:9012/predev/public/swagger`;

            delete request.headers.endpoint;
            request.method = 'post';

            // const response = await fetch("http://localhost:9002/dev/authenticateApi", {
            //     method: "POST",
            //     headers: { "Content-Type": "application/json" },
            //     body: JSON.stringify({
            //         SecretKey,
            //         AccessKeyId,
            //         SessionToken,
            //         method: request.method,
            //         path: endpoint.pathname,
            //         apiQuery: endpoint.search,
            //         apiBody: request.body ? JSON.parse(request.body) : undefined,
            //         hostUrl,
            //         hostRegion
            //     })
            // });

            // if (!response.ok) {
            //     throw new Error(`HTTP error! status: ${ response.status }`);
            // }

            // const { data } = await response.json();

            // console.log('headers', data);

            // // Merge the received headers with the existing request headers

            // // Ensure these specific headers are set correctly
            // request.headers['Content-Type'] = 'application/json';
            // // request.headers['host'] = data['host'];
            // request.headers['x-amz-date'] = data['x-amz-date'];
            // request.headers['x-amz-security-token'] = data['x-amz-security-token'];
            // request.headers['Authorization'] = data['Authorization'];
            // request.headers['Access-Control-Allow-Origin'] = '*';

            // const apiCallResponse = await axios({
            //     url: request.url,
            //     method: request.method,
            //     headers: request.headers,
            //     data: request.body
            // });

            // console.log('apiCall', apiCallResponse.data);

        } catch (error) {
            console.error('Error in request interceptor:', error);
        }

        console.log('Modified request', request);
        return request;
    }, []);

    return (
        <Authenticator hideSignUp>
            { ({ signOut, user }) => (
                <main>
                    <h1>Hello { user.username }</h1>
                    <button onClick={ signOut }>Sign out</button>
                    <SwaggerUI
                        spec={ require('./spec/swaggerUI.json') }
                        requestInterceptor={ requestInterceptor }
                    />
                </main>
            ) }
        </Authenticator>
    );
}
